import { EMPRESA_DEFAULT, ALMACEN_EMPRESA, NORMAS_SUGERIDAS } from "./constants";

export function leerEmpresaGuardada() {
  try {
    const raw = localStorage.getItem(ALMACEN_EMPRESA);
    const datos = raw ? JSON.parse(raw) : null;
    if (datos && typeof datos === "object") {
      return { ...EMPRESA_DEFAULT, ...datos };
    }
  } catch {
    // El almacenamiento es opcional.
  }
  return { ...EMPRESA_DEFAULT };
}

export function guardarEmpresa(empresa) {
  try {
    localStorage.setItem(ALMACEN_EMPRESA, JSON.stringify(empresa));
  } catch {
    // Ídem.
  }
}

export function toCertificado(item, empresaOverride) {
  if (!item) return null;
  const empresa = {
    ...EMPRESA_DEFAULT,
    ...(item.empresa || {}),
    ...(empresaOverride || {}),
  };

  return {
    folio: item.folio || "Se asignará al emitir",
    emitidoEn: item.emitidoEn || "",
    empresa: {
      nombre: empresa.nombre || EMPRESA_DEFAULT.nombre,
      giro: empresa.giro || EMPRESA_DEFAULT.giro,
      licencia: empresa.licencia || "—",
      licenciaVigencia: empresa.licenciaVigencia || "—",
    },
    cliente: item.cliente || "Cliente",
    lugar: item.lugar || "Domicilio del servicio",
    servicio: item.servicio || "Servicio de control de plagas",
    mes: item.mes || "—",
    fecha: item.fecha || "—",
    normas:
      Array.isArray(item.normas) && item.normas.length
        ? item.normas
        : [...NORMAS_SUGERIDAS],
    tecnico: {
      nombre: item.tecnico?.nombre || "Técnico responsable",
      puesto: item.tecnico?.puesto || "Técnico de campo",
    },
  };
}

export function normasToText(normas) {
  return (normas || []).join("\n");
}

export function textToNormas(text) {
  return String(text || "")
    .split("\n")
    .map((linea) => linea.trim())
    .filter(Boolean);
}
